import { useQuery } from "@tanstack/react-query";
import { getCommissionPayments } from "../api/commissionApi";
import { commissionKeys } from "../api/commissionKeys";

export const useCommissionPayments = () =>
  useQuery({
    queryKey: commissionKeys.payments(),
    queryFn: getCommissionPayments,
  });
